// import React from 'react'
// import { Link } from 'react-router-dom'

// const blogPosts = [
//   {
//     image: 'assets/images/blog/blog-2.png',
//     author: 'Sultan Ahmed',
//     designation: 'Consulting',
//     title: 'Consulted admitting wooded is power acuteness.',
//     link: '/BlogDetails',
//   },
//   {
//     image: 'assets/images/blog/blog-3.png',
//     author: 'Ayesha Khan',
//     designation: 'Marketing',
//     title: 'Grow your business strategy with business consulting.',
//     link: '/BlogDetails',
//   },
//   {
//     image: 'assets/images/blog/blog-1.png',
//     author: 'Imran Patel',
//     designation: 'Strategy Expert',
//     title: 'Facilis dolor eques about under official, presentism.',
//     link: '/BlogDetails',
//   },
// ]

// const Events = () => {
//   return (
//     <>
//       <div className="breadcrumb-area bg_image tmp-section-gap breadcrumb-bg">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-12">
//               <div className="breadcrumb-inner text-center">
//                 <h1 className="title split-collab">Events</h1>
//                 <ul className="page-list">
//                   <li className="tmp-breadcrumb-item"><a href="/">Home</a></li>
//                   <li className="icon"><i className="fa-solid fa-angle-right" /></li>
//                   <li className="tmp-breadcrumb-item active">Events</li>
//                 </ul>
//                 <div className="circle-1" />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="tmp-blog-area tmp-section-gap">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-12">
//               <div className="section-head">
//                 <div className="section-sub-title center-title">
//                   <img src="assets/images/services/section-custom-menubar.png" alt="Corporate_service" />
//                   <span className="subtitle">LATEST BLOG</span>
//                 </div>
//                 <h2 className="title split-collab">Latest News &amp; Articles</h2>
//               </div>
//             </div>
//           </div>

//           <div className="row g-5">
//             {blogPosts.map((post, index) => (
//               <div key={index} className="col-lg-4 col-md-6 col-sm-12 col1-2 wow fadeInLeft" data-wow-duration=".8s" data-wow-delay={`.${index + 1}s`}>
//                 {/* <div className="single-blog hover-card">
//                   <div className="blog-inner">
//                     <div className="thumbnail">
//                       <img src={post.image} alt={post.title} />
//                       <div className="overlay">
//                         <div className="text-content">
//                           <span className="name">{post.author}</span>
//                           <span className="designation">{post.designation}</span>
//                           <h4 className="title">{post.title}</h4>
//                           <Link className="btn-read-more" to={post.link}>
//                             <span className="read-more-text">Read More</span>
//                             <span className="read-more-icon"><i className="fa-solid fa-arrow-right" /></span>
//                           </Link>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div> */}

// <div
//   className="signle-product-start"
//   data-tmp-cursor="lg text-secondary transparent fw-bold"
//   data-tmp-cursor-icon="fa-solid fa-arrow-up-right"
// >
//   <img src={post.image} alt={post.title} />
  
//   <div className="inner-content">
//     <div className="info">
//       <h5 className="title" style={{ fontSize: '18px' }}>{post.title}</h5>
//       <span className="designation">{post.designation}</span>
//     </div>
//     <div className="tag" />
//   </div>
// </div>

//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }

// export default Events


import React from 'react'
import { Link } from 'react-router-dom'

const blogPosts = [
  {
    image: 'assets/images/v2vimages/eventpage-1.jpg',
    author: 'Event 1',
    designation: 'Ahemdabad',
    title: 'Connect with business leaders and visionaries to share insights and spark meaningful collaborations.',
    link: '#',
  },
  {
    image: 'assets/images/v2vimages/eventpage-2.jpg',
    author: 'Event 2',
    designation: 'Ahemdabad',
    title: 'Watch startups pitch live, meet investors, and explore the next wave of innovation.',
    link: '#',
  },
  {
    image: 'assets/images/v2vimages/eventpage-3.jpg',
    author: 'Event 3',
    designation: 'Ahemdabad',
    title: 'Empowering women entrepreneurs through mentorship and inspiring talks.',
    link: '#',
  },
]

const Events = () => {
  return (
    <>
      <div className="breadcrumb-area bg_image tmp-section-gap breadcrumb-bg">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="breadcrumb-inner text-center">
                <h1 className="title split-collab">Events</h1>
                <ul className="page-list">
                  <li className="tmp-breadcrumb-item"><a href="/">Home</a></li>
                  <li className="icon"><i className="fa-solid fa-angle-right" /></li>
                  <li className="tmp-breadcrumb-item active">Events</li>
                </ul>
                <div className="circle-1" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="tmp-blog-area tmp-section-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-head">
                <div className="section-sub-title center-title">
                  <img src="assets/images/services/section-custom-menubar.png" alt="Corporate_service" />
                  <span className="subtitle">LATEST Events
                  </span>
                </div>
                <h2 className="title split-collab">Be a Part of the Movement</h2>
              </div>
            </div>
          </div>

          <div className="row g-5">
            {blogPosts.map((post, index) => (
              <div key={index} className="col-lg-4 col-md-6 col-sm-12 col1-2 wow fadeInLeft" data-wow-duration=".8s" data-wow-delay={`.${index + 1}s`}>
                <div className="single-blog hover-card">
                  <div className="blog-inner">
                    <div className="thumbnail">
                      <img src={post.image} alt={post.title} />
                      <div className="overlay">
                        <div className="text-content">
                          <span className="name">{post.author}</span>
                          <span className="designation">{post.designation}</span>
                          <h4 className="title text-white">{post.title}</h4>
                          <Link className="btn-read-more" to={post.link}>
                            <span className="read-more-text">Join an Event</span>
                            <span className="read-more-icon"><i className="fa-solid fa-arrow-right" /></span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default Events
